import { render, staticRenderFns } from "./SQL.vue?vue&type=template&id=7bc94523&scoped=true&"
import script from "./SQL.vue?vue&type=script&lang=js&"
export * from "./SQL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc94523",
  null
  
)

export default component.exports